export const STORES = [
    'Cannon Ford of Cleveland',
    'Cannon Ford of Starkville',
    'Cannon Chevrolet Buick GMC',
    'Cannon Chevrolet Greenwood',
    'Cannon Chevrolet Buick GMC of West Point',
    'Cannon Chevrolet Buick Cadillac of Oxford',
    'Cannon Honda',
    'Cannon CDJR of Cleveland',
    'Cannon Ford of Pascagoula',
    'Cannon CDJR Greenwood',
    'Cannon Preowned Grenada',
    'Cannon Toyota of Vicksburg',
    'Cannon Toyota of Mosspoint',
    'Cannon Ford Nissan of Pascagula',
    'Cannon CDJR of West Point',
    'Cannon Preowned of Jackson',
    'Cannon Preowned Calhoun City',
    'Cannon Nissan of Greenwood',
    'Cannon Nissan of Jackson',
    'Cannon Nissan of Oxford',
    'Grenada Nissan',
    'Cannon Chevrolet Nissan of Laurel',
    'Cannon GMC Vicksburg'
]